// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ReadyPlanLikeButtonMenuFragmentDoc } from '../../../components/ReadyPlanButtonMenu.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignCatalogsTableQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.DesignPackageFilter>;
}>;


export type DesignCatalogsTableQuery = { __typename?: 'Query', designPackages: { __typename?: 'DesignPackagesPageResult', entities: Array<{ __typename?: 'DesignPackage', id: string, name: string, description?: string | null | undefined, code?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, isPlanSpecific?: boolean | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignUpgrade: boolean, forDesignPackages: boolean, designPackageTagColor?: string | null | undefined } } }>, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, readyPlan:
            | { __typename?: 'ReadyPlan', id: string, name: string }
            | { __typename?: 'PlanPackage', id: string, name: string }
            | { __typename?: 'DesignPackage', id: string, name: string }
            | { __typename?: 'ProductOffering', id: string, name: string }
           } }>, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type DesignPackageTableItemFragment = { __typename?: 'DesignPackage', id: string, name: string, description?: string | null | undefined, code?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, globalOption: { __typename?: 'GlobalOption', id: string, isPlanSpecific?: boolean | null | undefined, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignUpgrade: boolean, forDesignPackages: boolean, designPackageTagColor?: string | null | undefined } } }>, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
       } }>, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export const DesignPackageTableItemFragmentDoc = gql`
    fragment DesignPackageTableItem on DesignPackage {
  id
  name
  description
  code
  aggregateLatest {
    id
  }
  location {
    code
    name
  }
  status {
    code
    name
  }
  options {
    id
    displayName
    globalOption {
      id
      isPlanSpecific
      group {
        id
        name
        forDesignUpgrade
        forDesignPackages
        designPackageTagColor
      }
    }
  }
  availableUpdates {
    id
    planVersion {
      id
      version
      readyPlan {
        id
        name
      }
    }
  }
  ...ReadyPlanLikeButtonMenu
  updatedAt
}
    ${ReadyPlanLikeButtonMenuFragmentDoc}`;
export const DesignCatalogsTableDocument = gql`
    query DesignCatalogsTable($filter: DesignPackageFilter) {
  designPackages(filter: $filter) {
    entities {
      ...DesignPackageTableItem
    }
  }
}
    ${DesignPackageTableItemFragmentDoc}`;

/**
 * __useDesignCatalogsTableQuery__
 *
 * To run a query within a React component, call `useDesignCatalogsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignCatalogsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignCatalogsTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDesignCatalogsTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>(DesignCatalogsTableDocument, options);
      }
export function useDesignCatalogsTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>(DesignCatalogsTableDocument, options);
        }
// @ts-ignore
export function useDesignCatalogsTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>;
export function useDesignCatalogsTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignCatalogsTableQuery | undefined, DesignCatalogsTableQueryVariables>;
export function useDesignCatalogsTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>(DesignCatalogsTableDocument, options);
        }
export type DesignCatalogsTableQueryHookResult = ReturnType<typeof useDesignCatalogsTableQuery>;
export type DesignCatalogsTableLazyQueryHookResult = ReturnType<typeof useDesignCatalogsTableLazyQuery>;
export type DesignCatalogsTableSuspenseQueryHookResult = ReturnType<typeof useDesignCatalogsTableSuspenseQuery>;
export type DesignCatalogsTableQueryResult = Apollo.QueryResult<DesignCatalogsTableQuery, DesignCatalogsTableQueryVariables>;